// ========== Imports ==========
import { dateFormat } from 'helpers/StringNumberFunction/formatDate';
import { amtStr } from 'helpers/StringNumberFunction/numFormatter';

// ========== Component ==========
export const ELetterServiceCosting = ({
  docType,
  previewDetail,
  allpreviewDetail,
  getCompany,
  getJournalEntry,
  paramVal,
  getGlCostCentre,
  getGlMasterCOA,
}) => {
  const getCostCentreDetails = costCentreID => {
    if (!costCentreID || !getGlCostCentre || getGlCostCentre.length === 0) {
      return { code: '-', name: '-' };
    }

    const costCentre = getGlCostCentre.find(cc => cc.ID === costCentreID);
    return {
      code: costCentre?.Code || '-',
      name: costCentre?.Name || '-',
    };
  };

  const getMasterCOADetails = masterCOAID => {
    if (!masterCOAID || !getGlMasterCOA || getGlMasterCOA.length === 0) {
      return { code: '-', name: '-' };
    }

    const masterCOA = getGlMasterCOA.find(coa => coa.ID === masterCOAID);
    return {
      code: masterCOA?.Code || '-',
      name: masterCOA?.Name || '-',
    };
  };

  const journalEntry =
    getJournalEntry && getJournalEntry.length > 0
      ? getJournalEntry[0] // If it's an array with data, use first item
      : previewDetail; // Otherwise use previewDetail

  const detailItems = journalEntry?.costAdjustmentDetail || [];

  console.log('=== ELetterServiceCosting Debug ===');
  console.log('journalEntry:', journalEntry);
  console.log('detailItems:', detailItems);

  // ========== Document Type Processing ==========
  switch (docType) {
    case 'journal-entry':
      const result = Object.assign(paramVal, {
        // ==========================
        // COMPANY DETAILS
        // ==========================
        '[companyName]': getCompany?.[0]?.Name || '',
        '[companyRegNo]': getCompany?.[0]?.CompanyRegNo || '',
        '[companyAddress]': getCompany?.[0]?.Address?.address || '',
        '[companyContactNo]': getCompany?.[0]?.ContactNo || '',

        // ==========================
        // DOCUMENT DETAILS
        // ==========================
        '[docNo]': journalEntry?.docNo || '',
        '[docRef]': journalEntry?.docRef || '',
        '[description]': journalEntry?.description || '',
        '[docDate]': journalEntry?.docDate
          ? dateFormat(journalEntry.docDate)
          : '',
        '[transactionDate]': journalEntry?.transactionDate
          ? dateFormat(journalEntry.transactionDate)
          : '',
        '[docAmt]':
          journalEntry?.docAmt != null ? amtStr(journalEntry.docAmt) : '0.00',

        // ==========================
        // AUDIT/APPROVAL DETAILS
        // ==========================
        '[createdDate]':
          journalEntry?.auditLog?.createdTs ?? journalEntry?.createdTs
            ? dateFormat(
                journalEntry.auditLog.createdTs ?? journalEntry?.createdTs,
              )
            : '',
        '[preparedBy]': journalEntry?.auditLog?.createdName || '',
        '[approvedBy]': journalEntry?.auditLog?.modName || '',
        '[approvedDate]':
          journalEntry?.auditLog?.modTs ?? journalEntry?.modTs
            ? dateFormat(journalEntry.auditLog.modTs ?? journalEntry?.modTs)
            : '',

        // ==========================
        // DETAIL LINE ITEMS
        // ==========================
        items:
          detailItems?.map((el, i) => {
            const indexValue = i + 1;

            // Get the cost centre details using the costCentreID
            const costCentreDetails = getCostCentreDetails(el?.costCentreID);
            const masterCOADetails = getMasterCOADetails(el?.masterCOAID);

            const isProject = el?.accountType == 'PROJECT' ? true : false;
            const isGL = el?.accountType == 'GENERAL_LEDGER' ? true : false;

            return {
              '[index]': indexValue,

              // Project Data
              '[contractTitle]': isProject ? el?.contract?.title || '-' : '-',
              '[wbsName]': isProject
                ? el?.wbs
                  ? el.wbs.parentName
                    ? `${el.wbs.parentName} / ${el.wbs.name}`
                    : el.wbs.name
                  : '-'
                : '-',
              '[costCategory]': isProject ? el?.costCategory?.name || '-' : '-',
              '[itemName]': isProject ? el?.costItem?.name || '-' : '-',
              '[revenueCategory]': isProject
                ? el?.revenueCategory?.name || '-'
                : '-',

              // General Ledger Data
              '[glAccountCode]': isGL ? masterCOADetails?.code : '-',
              '[glAccountName]': isGL ? masterCOADetails?.name : '-',
              '[departmentCode]': isGL ? costCentreDetails.code : '-',
              '[departmentCodeName]': isGL ? costCentreDetails.name : '-',

              '[debitAmt]': el?.docAmt > 0 ? amtStr(el.docAmt) : '0.00',
              '[creditAmt]': el?.docAmt < 0 ? amtStr(el.docAmt * -1) : '0.00',
              '[remarks]': el?.remarks || '',
              '[accountType]': el?.accountType,
            };
          }) || [],

        '[sumDebitAmt]':
          journalEntry?.debitAmt != null
            ? amtStr(journalEntry.debitAmt)
            : '0.00',
        '[sumCreditAmt]':
          journalEntry?.creditAmt != null
            ? amtStr(journalEntry.creditAmt * -1)
            : '0.00',
      });
  }
};
